import api from './api';

export const kategoriDokumenService = {
    getAll: async () => {
        try {
            const response = await api.get('/kategori-dokumen');
            return { success: true, data: response.data?.data || response.data || [] };
        } catch (error) {
            return { success: false, message: 'Gagal mengambil data kategori' };
        }
    },
    create: async (payload) => {
        try {
            const response = await api.post('/kategori-dokumen', payload);
            return { success: true, data: response.data?.data || response.data };
        } catch (error) {
            return {
                success: false,
                message: error.response?.data?.message || 'Gagal menambahkan kategori',
            };
        }
    },
};